import * as React from 'react';

const MailboxChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="mailbox-chunky_svg__eds-icon--mailbox-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="mailbox-chunky_svg__eds-icon--mailbox-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 9.5C20 7.6 18.4 6 16.5 6H16V4h-2v2H8l.1.1C7.9 6 7.7 6 7.5 6 5.6 6 4 7.6 4 9.5V16h8v4h2v-4h6V9.5zM9 14H6V9.5C6 8.7 6.7 8 7.5 8S9 8.7 9 9.5V14zm9 0h-7V8h3v2h2V8h.5c.8 0 1.5.7 1.5 1.5V14z"
        />
    </svg>
);

MailboxChunkySvg.displayName = 'MailboxChunkySvg';
export default MailboxChunkySvg;
